module.exports = "<div class=\"c-narrow-col-timer\">\n\t<span class=\"c-narrow-col-timer__icon\"> <i class=\"icon__n icon__n--schedule\"></i>\n\t</span>\n\t<span class=\"c-narrow-col-timer__label\">{{expiresInFormatted}}</span>\n</div>\n<!-- end c-arrow-col-timer -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/narrow-col-timer/narrow-col-timer.component.html
// module id = ./src/app/modules/boxoffice-module/components/narrow-col-timer/narrow-col-timer.component.html
// module chunks = 9